import React, { useState } from "react";
import ChartGauge from "../Gauge";
import LcLoading from "../../Generic/LcLoading";
import HHClickList from "../../Data/HHClickList";
import HHTextToggle from "../../Form/HHTextToggle";
import LcIcon from "../../Generic/LcIcon";

interface ChartGaugeData {
  title: string,
  steps?: Array<{ percent: number, status: "success" | "warning" | "danger" | "info" }>,
  insideRadius?: string,
  value: number,
  overValue?: string,
}

interface HHClickListData {
  columns?: Array<{
    id?: string | number,
    name: string,
    header: string,
    width: string,
    align?: "center" | "left" | "right",
    color?: string,
    bold?: boolean,
    renderCell?: any
  }>,
  data: any[],
  loading: boolean,
}

interface Props {
  title: string,
  gaugeData: ChartGaugeData[],
  clickListData: HHClickListData[],
  size?: "tiny" | "small" | "medium-small" | "medium" | "big",
  detailed: boolean,
  onClickLine?: (row: any) => void,
  tooltipCanceled?: string
}

const GaugeDetailed: React.FC<Props> = (props) => {
  const [toggle, setToggle] = useState<string>("percent");

  const columnsToggle = {
    left: { label: "123", value: "value" },
    right: { label: "%", value: "percent" }
  };

  const columnsSteps: any[] = [
    { percent: 20, status: "danger" },
    { percent: 20, status: "warning" },
    { percent: 60, status: "success" }
  ];

  const columnsList: any[] = [
    { header: "", name: "id", width: "0px", color: "black", hidden: true },
    {
      header: "",
      name: "descricao",
      width: "70%",
      color: "black",
      renderCell: (row: any) => {
        return (<span style={{
          cursor: "pointer",
          // fontWeight: 600
        }} onClick={() => { props.onClickLine && props.onClickLine(row) }}>{row.descricao}</span>)
      }
    },
    {
      header: "",
      name: "count",
      width: "30%",
      align: "right",
      color: "black",
      bold: true,
      renderCell: (row: any) => {
        return (<span style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }} onClick={() => { props.onClickLine && props.onClickLine(row) }}>{row.count}</span>)
      }
    }
  ];

  return (
    // <div className={(props.detailed) ? "row space-between column top padding1p boxShadowLightBlack" : "chartbox wDash32p boxShadowLightBlack"}>
    <div className={(props.detailed) ? "chartbox boxShadowLightBlack" : "chartbox wDash32p boxShadowLightBlack"} style={{ width: "98%", height: "100%" }}>
      <div className="row start" style={{ paddingLeft: "16px", paddingTop: "6px", color: "#8B90A3", fontSize: "16px", justifyContent: "space-between", marginRight: "0px" }}>
        <div style={{ display: "flex", alignItems: 'center' }}>
          {props.title}
          {
            props.tooltipCanceled &&
            <LcIcon icon={"ppi ppi-information-circle"} tooltipPosition={"right"} size={"small"} color={"#000"} tooltip={props.tooltipCanceled} />
          }
        </div>

        <HHTextToggle
          onChange={event => setToggle(event.target.value)}
          options={columnsToggle}
          value={toggle}
        />
      </div>
      <div className="row space-between center" style={{ paddingTop: "20px", maxHeight: props.detailed ? "170px" : "190px" }}>
        {
          props.gaugeData.map((gauge, index) => {
            return (
              <div key={index} className="row center" style={{ width: "47.5%" }}>
                <ChartGauge
                  steps={gauge.steps || columnsSteps}
                  insideRadius={gauge.insideRadius || "75%"}
                  size={props.size || "medium"}
                  title={gauge.title}
                  value={gauge.value}
                  overValue={(toggle === "value") ? gauge.overValue : ""}
                />
              </div>
            )
          })
        }
      </div>
      {
        props.detailed &&
        <div className="row space-between" style={{ paddingTop: "10px", paddingLeft: "12px", paddingRight: "12px" }}>
          {
            props.clickListData.map((clickList, index) => {
              return (
                <LcLoading key={index} loading={clickList.loading}>
                  <div className="row center" style={{ width: "47.7%", marginTop: "10px" }}>
                    <HHClickList
                      columns={clickList.columns || columnsList}
                      data={clickList.data}
                      onCLick={row => undefined}
                      rowLink={true}
                    />
                  </div>
                </LcLoading>
              )
            })
          }
        </div>
      }
    </div>
  );
}

export default GaugeDetailed;